import * as React from 'react';

function WaitNode(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 191 \u2013 23">
        <g filter="url(#prefix__a)">
          <g
            data-name="Path 376"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.selected ? '#fff' : '#f07663'}
          >
            <path d="M26 46.5a20.432 20.432 0 01-14.496-6.004A20.432 20.432 0 015.5 26a20.432 20.432 0 016.004-14.496A20.432 20.432 0 0126 5.5a20.432 20.432 0 0114.496 6.004A20.432 20.432 0 0146.5 26a20.432 20.432 0 01-6.004 14.496A20.432 20.432 0 0126 46.5z" />
            <path
              d="M26 6a19.935 19.935 0 00-14.142 5.858A19.935 19.935 0 006 26a19.935 19.935 0 005.858 14.142A19.935 19.935 0 0026 46a19.935 19.935 0 0014.142-5.858A19.935 19.935 0 0046 26a19.935 19.935 0 00-5.858-14.142A19.935 19.935 0 0026 6m0-1c11.598 0 21 9.402 21 21s-9.402 21-21 21S5 37.598 5 26 14.402 5 26 5z"
              fill="#e78e7a"
            />
          </g>
        </g>
        <g
          data-name="Icon ionic-ios-timer"
          fill={props.selected ? '#fff' : '#f07663'}
        >
          <path
            data-name="Path 362"
            d="M26.502 35.502a9.248 9.248 0 01-6.418-15.906.743.743 0 111.033 1.068 7.761 7.761 0 106.127-2.136v2.894a.745.745 0 01-1.489 0v-3.671a.744.744 0 01.744-.744 9.25 9.25 0 010 18.5z"
          />
          <path
            data-name="Path 363"
            d="M22.507 21.488l5.474 3.937a1.659 1.659 0 11-1.927 2.7 1.6 1.6 0 01-.385-.385l-3.937-5.478a.552.552 0 01.771-.771z"
          />
        </g>
      </g>
    </svg>
  );
}

function DecisionNode(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 60 60.014" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={60}
          height={60.014}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 175 \u2013 185">
        <g filter="url(#prefix__a)" data-name="Component 170 \u2013 14">
          <g
            data-name="Rectangle 1029"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke="#f07663"
            strokeLinejoin="round"
            strokeWidth={1.5}
          >
            <path
              stroke="none"
              d="M9 26.44L30.185 6.137 50.88 27.731 29.694 48.034z"
            />
            <path
              fill="none"
              d="M10.058 26.463L30.163 7.195l19.659 20.513-20.106 19.268z"
              strokeWidth={1.4958749999999998}
            />
          </g>
        </g>
        <text
          transform="translate(17.001 19)"
          fill={props.selected ? '#fff' : '#f07663'}
          fontSize={12}
          fontFamily="Nunito-Medium, Nunito"
          fontWeight={500}
        >
          <tspan x={5.563} y={12}>
            {'D1'}
          </tspan>
        </text>
      </g>
    </svg>
  );
}

function StopNode(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 238 \u2013 8">
        <g filter="url(#prefix__a)" data-name="Component 224 \u2013 1">
          <g data-name="Path 370" fill="#fff">
            <path d="M26 46.5a20.432 20.432 0 01-14.496-6.004A20.432 20.432 0 015.5 26a20.432 20.432 0 016.004-14.496A20.432 20.432 0 0126 5.5a20.432 20.432 0 0114.496 6.004A20.432 20.432 0 0146.5 26a20.432 20.432 0 01-6.004 14.496A20.432 20.432 0 0126 46.5z" />
            <path
              d="M26 6a19.935 19.935 0 00-14.142 5.858A19.935 19.935 0 006 26a19.935 19.935 0 005.858 14.142A19.935 19.935 0 0026 46a19.935 19.935 0 0014.142-5.858A19.935 19.935 0 0046 26a19.935 19.935 0 00-5.858-14.142A19.935 19.935 0 0026 6m0-1c11.598 0 21 9.402 21 21s-9.402 21-21 21S5 37.598 5 26 14.402 5 26 5z"
              fill="#e78e7a"
            />
          </g>
        </g>
        <g
          data-name="Icon feather-stop-circle"
          fill="none"
          stroke="#e6715f"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        >
          <path
            data-name="Path 6892"
            d="M37.554 26A11.554 11.554 0 1126 14.446 11.554 11.554 0 0137.554 26z"
          />
          <path data-name="Path 6893" d="M22.534 22.534h6.932v6.932h-6.932z" />
        </g>
      </g>
    </svg>
  );
}

function Decision(props) {
  return (
    <svg width="46px" height="46px" viewBox="0 0 35.35 35.35" {...props}>
      <g data-name="Component 170 \u2013 1">
        <g
          data-name="Rectangle 1029"
          fill="#fff"
          stroke="#F07663"
          strokeLinejoin="round"
          strokeWidth={1}
        >
          <path
            stroke="none"
            d="M0 17.366L17.975-.009 35.35 17.966 17.375 35.341z"
          />
          <path
            fill="none"
            d="M1.414 17.39L17.951 1.405l15.985 16.537-16.537 15.985z"
            strokeWidth={1}
          />
        </g>
        <path
          d="M17.321 12.116c-1.021 0-2.884.982-2.943 1.858s.119.93.2.977h.96a1.109 1.109 0 011.188-.779 1.3 1.3 0 011.146 1.66c-.324.777-.625 1.047-1.024 1.887a3.776 3.776 0 00-.008 3.164l1.184.021c-.293-1.506 1.258-2.847 1.875-3.774a3 3 0 00.682-2.047 2.938 2.938 0 00-.84-2.049 3.26 3.26 0 00-2.42-.918zm.059 9.769a1.434 1.434 0 101.434 1.431 1.431 1.431 0 00-1.432-1.431z"
          fill="#F07663"
        />
      </g>
    </svg>
  );
}

function LeadToOrder(props) {
  return (
    <svg width="20px" height="20px" viewBox="0 0 23.953 16" {...props}>
      <path
        data-name="Icon payment-cash"
        d="M23.951.795v14.409a1.027 1.027 0 01-.234.561.764.764 0 01-.561.234H.795a.762.762 0 01-.561-.234A1.023 1.023 0 010 15.204V.795A1.025 1.025 0 01.234.234.766.766 0 01.795 0h22.363a.767.767 0 01.561.234 1.03 1.03 0 01.234.561zm-1.588 10.386V4.818a3.06 3.06 0 01-2.246-.936 3.115 3.115 0 01-.936-2.292H4.772a3.117 3.117 0 01-.936 2.292 3.062 3.062 0 01-2.246.936v6.363a3.065 3.065 0 012.246.936 3.119 3.119 0 01.936 2.292h14.409a3.117 3.117 0 01.936-2.292 3.064 3.064 0 012.246-.935zM15.951 8a8.2 8.2 0 01-.234 1.778 6 6 0 01-.748 1.684 4.066 4.066 0 01-1.263 1.263 3.436 3.436 0 01-3.462 0 4.052 4.052 0 01-1.263-1.263 5.98 5.98 0 01-.748-1.684A8.16 8.16 0 017.999 8a8.167 8.167 0 01.234-1.778 5.977 5.977 0 01.748-1.684 4.066 4.066 0 011.27-1.263 3.435 3.435 0 013.461 0 4.086 4.086 0 011.263 1.263 6 6 0 01.748 1.684A8.191 8.191 0 0115.951 8zm-6.36 3.181h4.772v-1.17h-1.591V4.397h-1.4L9.501 6.128l.982.982a7.66 7.66 0 00.655-.7h.047v3.6H9.591v1.17z"
        fill="#666"
      />
    </svg>
  );
}

function ExistingCustomer(props) {
  return (
    <svg width="20px" height="20px" viewBox="0 0 10 16.57" {...props}>
      <path
        d="M5.776 3.069a1.5 1.5 0 01-1.1-.451 1.48 1.48 0 01-.451-1.083 1.475 1.475 0 01.45-1.084 1.569 1.569 0 012.2 0 1.474 1.474 0 01.451 1.083 1.479 1.479 0 01-.451 1.083 1.5 1.5 0 01-1.099.452zM2.924 5.7L.758 16.57h1.624L3.79 10.4l1.588 1.552v4.618h1.553v-5.776L5.307 9.242l.469-2.311A5.347 5.347 0 0010 8.844V7.328A3.724 3.724 0 018.069 6.8a3.655 3.655 0 01-1.354-1.349L5.92 4.224a1.512 1.512 0 00-1.3-.758 1.831 1.831 0 00-.307.036 1.831 1.831 0 01-.307.036L0 5.235v3.61h1.552v-2.6L2.924 5.7z"
        fill="#666"
      />
    </svg>
  );
}
function Notify(props) {
  return (
    <svg width="20px" height="20px" viewBox="0 0 16 16" {...props}>
      <path
        d="M15.751.1a.558.558 0 01.241.572l-2.29 13.712a.562.562 0 01-.286.4.547.547 0 01-.277.072.6.6 0 01-.214-.044l-4.04-1.651-2.161 2.633a.526.526 0 01-.438.206.485.485 0 01-.2-.036.571.571 0 01-.375-.536v-3.116l7.714-9.455-9.54 8.259L.358 9.67a.565.565 0 01-.071-1.018L15.143.08a.545.545 0 01.286-.08.553.553 0 01.321.1z"
        fill="#666"
      />
    </svg>
  );
}

function Act(props) {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M14.613 1.298a.625.625 0 01.386.577V5h3.125a.625.625 0 01.443 1.068l-2.5 2.5a.625.625 0 01-.443.182h-3.491l-.925.927A1.251 1.251 0 118.749 10l.001-.057a1.25 1.25 0 011.573-1.15l.926-.926V4.375a.626.626 0 01.183-.442l2.5-2.5a.625.625 0 01.681-.135zm.753 6.202l1.25-1.25h-2.242a.625.625 0 01-.625-.625V3.384l-1.25 1.25V7.5h2.867zm2.064 1.47a7.5 7.5 0 11-6.402-6.4l-.479.479c-.198.198-.35.438-.442.703l-.108-.002a6.25 6.25 0 106.25 6.143c.264-.093.503-.244.7-.441l.48-.482h.002zM10 5.625A4.375 4.375 0 1014.373 10h-1.25A3.125 3.125 0 1110 6.875v-1.25z"
        fill="#666"
      />
    </svg>
  );
}
function Reward(props) {
  return (
    <svg width="20px" height="20px" viewBox="0 0 21.25 19.951" {...props}>
      <g data-name="Group 7968">
        <path
          data-name="Path 6879"
          d="M7.302 14.711H5.994v-2.179h2.179l.218.817a1.114 1.114 0 01-1.089 1.362z"
          fill="#666"
        />
        <path
          data-name="Path 6880"
          d="M17.981 16.346s-6.429-3.814-9.808-3.814V4.904c3.16 0 9.808-3.814 9.808-3.814z"
          fill="#d6d6d7"
        />
      </g>
      <g data-name="Group 7969" fill="#666">
        <path
          data-name="Path 6881"
          d="M5.449 8.718a2.724 2.724 0 11-2.725-2.724 2.724 2.724 0 012.725 2.724z"
        />
        <path
          data-name="Path 6882"
          d="M19.616 7.084h-1.635v3.269h1.635a1.635 1.635 0 000-3.269z"
        />
        <path
          data-name="Path 6883"
          d="M7.955 19.18a5.666 5.666 0 01-2.506.763.7.7 0 01-.763-.545l-2.4-7.465s4.795-3.378 4.795.6a9.482 9.482 0 001.2 5.176 1.063 1.063 0 010 1.253 1.14 1.14 0 01-.326.218z"
        />
      </g>
      <path
        data-name="Path 6884"
        d="M2.725 12.532h5.449V4.904H2.725a1.093 1.093 0 00-1.09 1.09v5.449a1.093 1.093 0 001.09 1.089z"
        fill="#abaaad"
      />
      <path
        data-name="Path 6885"
        d="M18.526 17.436a1.093 1.093 0 01-1.09-1.09V1.09a1.09 1.09 0 112.179 0v15.256a1.093 1.093 0 01-1.089 1.09z"
        fill="#abaaac"
      />
    </svg>
  );
}
function More(props) {
  return (
    <svg width="20px" height="20px" viewBox="0 0 17.494 13.435" {...props}>
      <path
        data-name="Icon material-more"
        d="M16.037 0H5.1a1.365 1.365 0 00-1.159.657L0 6.718l3.944 6.053a1.46 1.46 0 001.21.664h10.883a1.48 1.48 0 001.458-1.493V1.493A1.48 1.48 0 0016.037 0zM6.56 7.837a1.12 1.12 0 111.093-1.12 1.105 1.105 0 01-1.093 1.12zm3.645 0a1.12 1.12 0 111.093-1.12 1.105 1.105 0 01-1.093 1.12zm3.645 0a1.12 1.12 0 111.093-1.12 1.105 1.105 0 01-1.093 1.12z"
        fill="#666"
      />
    </svg>
  );
}

function SalesOrder(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 39 \u2013 1">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 264"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <path
          data-name="Icon awesome-file-invoice-dollar"
          d="M33.742 20.181l-4.1-4.1a1 1 0 00-.709-.294h-.255v5.357h5.357v-.257a1 1 0 00-.293-.706zm-6.4 1.3v-5.694h-8.377a1 1 0 00-1 1v19.422a1 1 0 001 1H33.03a1 1 0 001-1V22.487h-5.687a1.007 1.007 0 01-1.004-1.009zm-6.7-2.678a.335.335 0 01.335-.335h3.349a.335.335 0 01.335.335v.67a.335.335 0 01-.335.335h-3.348a.335.335 0 01-.335-.335zm0 3.348v-.67a.335.335 0 01.335-.335h3.349a.335.335 0 01.335.335v.67a.335.335 0 01-.335.335h-3.348a.335.335 0 01-.335-.338zm6.023 11.036v1.009a.335.335 0 01-.335.335h-.665a.335.335 0 01-.335-.335v-1.009a2.4 2.4 0 01-1.313-.475.335.335 0 01-.024-.508l.492-.469a.343.343 0 01.424-.031 1.008 1.008 0 00.536.156h1.177a.526.526 0 00.494-.552.546.546 0 00-.367-.533l-1.884-.568a1.894 1.894 0 01-1.321-1.82 1.864 1.864 0 011.786-1.886v-1.005a.335.335 0 01.335-.335h.67a.335.335 0 01.335.335v1.017a2.393 2.393 0 011.313.475.335.335 0 01.024.508l-.492.469a.343.343 0 01-.424.031 1 1 0 00-.536-.156h-1.178a.526.526 0 00-.494.552.546.546 0 00.367.533l1.883.565a1.894 1.894 0 011.322 1.816 1.863 1.863 0 01-1.79 1.881z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}

function NewLead(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 44 \u2013 1">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 264"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <path
          data-name="Icon awesome-walking"
          d="M28.336 18.204a2.338 2.338 0 10-2.338-2.339 2.339 2.339 0 002.338 2.339zm4.6 7.263l-1.133-.575-.473-1.432a5.312 5.312 0 00-4.979-3.7c-1.754 0-2.723.492-4.545 1.228a4.647 4.647 0 00-2.419 2.253l-.326.663a1.564 1.564 0 00.692 2.09 1.538 1.538 0 002.07-.7l.326-.663a1.548 1.548 0 01.8-.75l1.306-.526-.74 2.957a3.129 3.129 0 00.726 2.864l2.918 3.186a3.144 3.144 0 01.726 1.349l.891 3.571a1.56 1.56 0 103.027-.755l-1.08-4.332a3.116 3.116 0 00-.726-1.349l-2.216-2.419.838-3.347.268.8a3.107 3.107 0 001.544 1.8l1.135.575a1.538 1.538 0 002.07-.7 1.577 1.577 0 00-.7-2.095zm-11.147 6.854a3.023 3.023 0 01-.692 1.047l-2.436 2.441a1.559 1.559 0 002.2 2.207l2.896-2.889a3.166 3.166 0 00.692-1.047l.654-1.653c-2.694-2.938-1.885-2.036-2.309-2.616l-1.005 2.51z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}

function AbandonedCart(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 36 \u2013 1">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 263"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <path
          data-name="Icon material-remove-shopping-cart"
          d="M36.355 37.198L18.17 19.013l-.7-.7-.667-.672-1.157 1.162 4 4 2.013 4.246-1.23 2.232a1.762 1.762 0 00-.228.875 1.828 1.828 0 001.822 1.822h6.8l1.257 1.257a1.817 1.817 0 102.533 2.533l2.587 2.587 1.157-1.157zm-13.949-7.043a.226.226 0 01-.228-.228l.027-.109.82-1.485h2.151l1.822 1.822zm7.407-1.822a1.814 1.814 0 001.594-.938l3.262-5.913a.89.89 0 00.109-.437.914.914 0 00-.911-.911H21.604zm-7.79 4.555a1.822 1.822 0 101.823 1.822 1.82 1.82 0 00-1.822-1.822z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}
function SendSms(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 47 \u2013 1">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 262"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <path
          data-name="Icon material-comment"
          d="M34.538 20.888a1.707 1.707 0 00-1.701-1.709H19.162a1.714 1.714 0 00-1.709 1.709v10.256a1.714 1.714 0 001.709 1.709h11.966l3.419 3.419zm-3.41 8.547H20.872v-1.709h10.256zm0-2.564H20.872v-1.709h10.256zm0-2.564H20.872v-1.709h10.256z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}

function SendEmail(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 214 \u2013 2">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 262"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <g
          data-name="Icon feather-mail"
          fill="none"
          stroke={props.selected ? '#fff' : '#f07663'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        >
          <path
            data-name="Path 6886"
            d="M18.678 18.678h14.644a1.836 1.836 0 011.826 1.83v10.983a1.836 1.836 0 01-1.83 1.83h-14.64a1.836 1.836 0 01-1.83-1.83V20.508a1.836 1.836 0 011.83-1.83z"
            stroke={props.selected ? '#fff' : '#f07663'}
          />
          <path
            data-name="Path 6887"
            d="M35.148 20.508l-9.152 6.407-9.148-6.407"
            stroke={props.selected ? '#fff' : '#f07663'}
          />
        </g>
      </g>
    </svg>
  );
}

function SendWebPush(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 221 \u2013 3">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 262"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <g fill={props.selected ? '#fff' : '#f07663'}>
          <path
            data-name="Path 6888"
            d="M31.959 33.767h-5.165V26.15l2.617 2.616a.795.795 0 001.124-1.122l-3.974-3.973a.8.8 0 00-1.123 0l-3.972 3.973a.795.795 0 001.123 1.123l2.617-2.616v7.616h-5.165a2.784 2.784 0 01-2.781-2.781V20.657a2.784 2.784 0 012.781-2.781h11.918a2.784 2.784 0 012.781 2.781v10.329a2.784 2.784 0 01-2.781 2.781z"
          />
          <path
            data-name="Path 6889"
            d="M26.794 39.329a.795.795 0 01-1.589 0v-5.562h1.589z"
          />
        </g>
      </g>
    </svg>
  );
}

function GiveOffer(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 49 \u2013 1">
        <g filter="url(#prefix__a)">
          <path
            data-name="Path 369"
            d="M26 5A21 21 0 115 26 21 21 0 0126 5z"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <g
          data-name="Icon feather-percent"
          fill="none"
          stroke={props.selected ? '#fff' : '#f07663'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        >
          <path data-name="Path 341" d="M32.393 19.607L19.607 32.393" />
          <path
            data-name="Path 342"
            d="M23.26 20.977a2.283 2.283 0 11-2.283-2.283 2.283 2.283 0 012.283 2.283z"
          />
          <path
            data-name="Path 343"
            d="M33.306 31.023a2.283 2.283 0 11-2.283-2.283 2.283 2.283 0 012.283 2.283z"
          />
        </g>
      </g>
    </svg>
  );
}

function ProductView(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 38 \u2013 1">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 261"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <g
          data-name="Icon feather-eye"
          fill="none"
          stroke={props.selected ? '#fff' : '#f07663'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        >
          <path
            data-name="Path 337"
            d="M15.087 26s3.968-7.936 10.912-7.936S36.911 26 36.911 26s-3.968 7.936-10.912 7.936S15.087 26 15.087 26z"
          />
          <path
            data-name="Path 338"
            d="M28.975 26a2.976 2.976 0 11-2.976-2.976A2.976 2.976 0 0128.975 26z"
          />
        </g>
      </g>
    </svg>
  );
}
function SendWhatsapp(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 215 \u2013 8">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 619"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <path
          data-name="Icon ionic-logo-whatsapp"
          d="M26.25 12a13.693 13.693 0 00-13.742 13.639 13.5 13.5 0 001.972 7.043L12 40l7.61-2.418A13.769 13.769 0 0040 25.639 13.693 13.693 0 0026.25 12zm6.835 18.819a3.55 3.55 0 01-2.431 1.567c-.645.034-.663.5-4.177-1.027s-5.628-5.24-5.795-5.479a6.741 6.741 0 01-1.3-3.653 3.9 3.9 0 011.338-2.858 1.346 1.346 0 01.952-.4c.277 0 .456-.008.661 0s.512-.043.778.665.9 2.447.984 2.624a.637.637 0 01.006.611 2.387 2.387 0 01-.373.568c-.183.2-.386.44-.55.591-.182.167-.373.348-.181.7a10.519 10.519 0 001.861 2.484 9.59 9.59 0 002.764 1.838c.345.188.55.167.764-.058s.915-.984 1.162-1.323.479-.273.8-.146 2.01 1.035 2.355 1.222.575.283.657.431a2.887 2.887 0 01-.271 1.643z"
          fill="#0cc144"
        />
      </g>
    </svg>
  );
}

function FbMessenger(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 213 \u2013 3">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 620"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <path
          data-name="Icon awesome-facebook-messenger"
          d="M26.03 12.484c-7.632 0-13.547 5.578-13.547 13.112a12.815 12.815 0 004.255 9.7c.455.409.361.646.439 3.174a1.086 1.086 0 001.52.958c2.884-1.27 2.921-1.37 3.41-1.237 8.355 2.3 17.412-3.047 17.412-12.593.001-7.536-5.856-13.114-13.489-13.114zm8.135 10.091l-3.979 6.3a2.037 2.037 0 01-2.938.541l-3.166-2.369a.818.818 0 00-.981 0l-4.272 3.24a.643.643 0 01-.933-.854l3.979-6.3a2.036 2.036 0 012.938-.541l3.165 2.369a.818.818 0 00.981 0l4.274-3.24a.641.641 0 01.932.851z"
          fill="#327ae6"
        />
      </g>
    </svg>
  );
}

function OrderPlaced(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="b" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#prefix__a)">
        <circle
          cx={21}
          cy={21}
          r={21}
          transform="translate(5 5)"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
      </g>
      <path
        className="prefix__b"
        d="M33.411 15a4.707 4.707 0 104.708 4.707A4.707 4.707 0 0033.411 15zm2.41 3.406l-3.025 3.039a.409.409 0 01-.263.124.4.4 0 01-.265-.129l-1.269-1.267a.09.09 0 010-.129l.4-.4a.088.088 0 01.127 0l1 1 2.768-2.779a.089.089 0 01.063-.027.082.082 0 01.063.027l.4.41a.089.089 0 01.002.131zM22.701 22.949l-6.237 2.34a1.441 1.441 0 00-.933 1.349v6.75a1.439 1.439 0 00.795 1.286l6.238 3.119a1.429 1.429 0 001.286 0l6.238-3.119a1.437 1.437 0 00.795-1.286v-6.75a1.437 1.437 0 00-.933-1.346l-6.238-2.34a1.414 1.414 0 00-1.011-.003zm.507 1.862l5.758 2.159v.033l-5.758 2.34-5.758-2.339v-.033zm.96 10.676v-4.465l4.8-1.949v4.015z"
        fill={props.selected ? '#fff' : '#f07663'}
      />
    </svg>
  );
}

function CaptureWishlist(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="b" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#prefix__a)">
        <circle
          cx={21}
          cy={21}
          r={21}
          transform="translate(5 5)"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
      </g>
      <path
        className="prefix__b"
        d="M29.462 17.352a4.473 4.473 0 00-6.1.445l-.644.664-.644-.664a4.473 4.473 0 00-6.1-.445 4.7 4.7 0 00-.324 6.8l6.33 6.536a1.026 1.026 0 001.482 0l6.33-6.536a4.694 4.694 0 00-.321-6.8zM38.624 31.293H28.511v1.685h10.113zm0-3.371H28.511v1.685h10.113zm-10.113 8.427h6.742v-1.685h-6.742z"
        fill={props.selected ? '#fff' : '#f07663'}
      />
    </svg>
  );
}

function FbInterest(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 42 \u2013 1">
        <g data-name="Component 41 \u2013 1">
          <g filter="url(#prefix__a)" data-name="Component 156 \u2013 4">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
          <path
            data-name="Icon awesome-facebook"
            d="M36.335 26.065a10.335 10.335 0 10-11.95 10.207v-7.223H21.76v-2.984h2.625v-2.28a3.646 3.646 0 013.9-4.02 15.9 15.9 0 012.314.2v2.543h-1.296a1.494 1.494 0 00-1.684 1.614v1.943h2.866l-.458 2.987h-2.412v7.222a10.338 10.338 0 008.72-10.209z"
            fill="#3581f2"
          />
        </g>
        <path
          data-name="Icon metro-heart"
          d="M48.78 4a5.1 5.1 0 00-4.243 3.124A5.1 5.1 0 0040.293 4a4.693 4.693 0 00-4.691 4.691c0 5.267 5.314 6.649 8.935 11.856 3.423-5.175 8.934-6.757 8.934-11.856A4.693 4.693 0 0048.78 4z"
          fill="#f07663"
        />
      </g>
    </svg>
  );
}

function DroppedOffActivation(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="b" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#prefix__a)">
        <circle
          cx={21}
          cy={21}
          r={21}
          transform="translate(5 5)"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
      </g>
      <path
        className="prefix__b"
        d="M36.565 21.71h-5.227a.467.467 0 00-.436.491v.984a.467.467 0 00.436.491h5.227a.467.467 0 00.436-.491v-.982a.467.467 0 00-.436-.493zM25.469 19.471a1.958 1.958 0 10-1.958-1.959 1.959 1.959 0 001.958 1.959zm3.856 6.083l-.951-.481-.4-1.2a4.448 4.448 0 00-4.17-3.1 8.972 8.972 0 00-3.802 1.031 3.892 3.892 0 00-2.028 1.885l-.273.555a1.31 1.31 0 00.579 1.75 1.288 1.288 0 001.734-.583l.274-.557a1.3 1.3 0 01.673-.628l1.093-.441-.62 2.477a2.62 2.62 0 00.608 2.4l2.44 2.669a2.633 2.633 0 01.608 1.13l.75 2.993a1.306 1.306 0 102.534-.632l-.906-3.631a2.61 2.61 0 00-.608-1.13l-1.856-2.031.7-2.8.224.673a2.6 2.6 0 001.293 1.51l.951.481a1.288 1.288 0 001.734-.583 1.321 1.321 0 00-.581-1.757zm-9.343 5.74a2.532 2.532 0 01-.579.877l-2.037 2.045a1.305 1.305 0 101.844 1.848l2.423-2.423a2.652 2.652 0 00.579-.877l.551-1.379c-2.255-2.461-1.581-1.706-1.933-2.192l-.848 2.101z"
        fill={props.selected ? '#fff' : '#f07663'}
      />
    </svg>
  );
}

function CrossSell(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="b" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#prefix__a)">
        <circle
          cx={21}
          cy={21}
          r={21}
          transform="translate(5 5)"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
      </g>
      <path
        className="prefix__b"
        d="M14 21.375a.963.963 0 01.279-.709.955.955 0 01.707-.279h5.035a.981.981 0 01.611.2.955.955 0 01.354.548l.514 2.109h14.442l.151-.451a.887.887 0 01.921-.687.658.658 0 01.279.043.923.923 0 01.514.344.94.94 0 01.193.58 1.2 1.2 0 01-.043.279l-2.529 8.443a.924.924 0 01-.343.516.94.94 0 01-.579.193H22.529a.951.951 0 01-.611-.214 1 1 0 01-.354-.538l-2.314-9.41h-4.264a.968.968 0 01-.7-.279.918.918 0 01-.286-.688zm7.97 3.824l1.33 5.328h10.479l.042-.193 1.544-5.134H21.97zm.9 10.4a1.888 1.888 0 01.589-1.4 1.933 1.933 0 011.4-.58 1.976 1.976 0 010 3.952 1.932 1.932 0 01-1.4-.579 1.89 1.89 0 01-.589-1.395zm1.393-8.722h3.557v1.976h-3.128zm5.25 1.976l.021-1.976h3.471l-.514 1.976zm.793 6.746a1.888 1.888 0 01.59-1.4 1.931 1.931 0 011.4-.58 1.976 1.976 0 010 3.952 1.931 1.931 0 01-1.4-.579 1.888 1.888 0 01-.589-1.395z"
        fill={props.selected ? '#fff' : '#f07663'}
      />
      <path
        className="prefix__b"
        d="M33.524 22.161h1.79v-2.685h2.685v-1.791h-2.684V15h-1.79v2.685h-2.686v1.79h2.685z"
        fill={props.selected ? '#fff' : '#f07663'}
      />
    </svg>
  );
}

function AddToCart(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 37 \u2013 1">
        <g filter="url(#prefix__a)">
          <circle
            data-name="Ellipse 262"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <path
          data-name="Icon material-add-shopping-cart"
          d="M25.919 25.178h2.139V21.97h3.209v-2.139h-3.214v-3.209h-2.134v3.209h-3.213v2.139h3.213zm-4.283 9.626a2.139 2.139 0 102.139 2.139 2.136 2.136 0 00-2.139-2.139zm10.7 0a2.139 2.139 0 102.139 2.139 2.136 2.136 0 00-2.144-2.139zm-10.517-3.476l.032-.128.963-1.743h7.968a2.129 2.129 0 001.872-1.1l4.128-7.5-1.863-1.026h-.01l-1.177 2.139-2.952 5.352h-7.508l-.139-.289-2.4-5.059-1.014-2.143-1-2.139h-3.5v2.139h2.139l3.85 8.118-1.444 2.62a2.068 2.068 0 00-.267 1.027 2.145 2.145 0 002.139 2.139H34.47v-2.14H22.085a.272.272 0 01-.266-.267z"
          fill="#f07663"
        />
      </g>
    </svg>
  );
}

function InstaInterest(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 42 \u2013 1">
        <g data-name="Component 41 \u2013 1">
          <g filter="url(#prefix__a)" data-name="Component 156 \u2013 4">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
          <g data-name="Group 8035" transform="translate(14 14)" fill="#707070">
            <path
              data-name="Path 6931"
              d="M12 2.162c3.2 0 3.582.011 4.847.07a6.583 6.583 0 012.228.415 3.967 3.967 0 012.274 2.274 6.674 6.674 0 01.415 2.228c.056 1.265.07 1.645.07 4.847s-.011 3.582-.07 4.847a6.583 6.583 0 01-.415 2.229 3.967 3.967 0 01-2.274 2.274 6.672 6.672 0 01-2.228.415c-1.265.056-1.645.07-4.847.07s-3.582-.011-4.847-.07a6.581 6.581 0 01-2.228-.415 3.968 3.968 0 01-2.274-2.274 6.673 6.673 0 01-.415-2.229c-.056-1.265-.07-1.645-.07-4.847s.011-3.582.07-4.847a6.582 6.582 0 01.415-2.228 3.968 3.968 0 012.274-2.274 6.674 6.674 0 012.228-.415c1.265-.06 1.645-.07 4.847-.07M12 0C8.742 0 8.334.014 7.054.074A8.817 8.817 0 004.14.633a5.791 5.791 0 00-2.123 1.381A5.9 5.9 0 00.632 4.141a8.87 8.87 0 00-.559 2.914c-.06 1.279-.074 1.687-.074 4.946s.014 3.666.074 4.946a8.817 8.817 0 00.559 2.914 6.155 6.155 0 003.511 3.5 8.871 8.871 0 002.914.559c1.279.06 1.687.074 4.946.074s3.666-.014 4.946-.074a8.818 8.818 0 002.914-.559 6.155 6.155 0 003.5-3.511 8.87 8.87 0 00.559-2.914c.06-1.279.074-1.687.074-4.945s-.014-3.666-.074-4.946a8.818 8.818 0 00-.559-2.914 6.155 6.155 0 00-3.511-3.5 8.871 8.871 0 00-2.914-.559c-1.276-.056-1.684-.07-4.942-.07z"
            />
            <path
              data-name="Path 6932"
              d="M12 5.842a6.154 6.154 0 106.154 6.154A6.155 6.155 0 0012 5.842zm0 10.15a4 4 0 114-4 4 4 0 01-4 4z"
            />
            <circle
              data-name="Ellipse 621"
              cx={1.443}
              cy={1.443}
              r={1.443}
              transform="translate(16.96 4.15)"
            />
          </g>
        </g>
        <path
          data-name="Icon metro-heart"
          d="M48.78 4a5.1 5.1 0 00-4.243 3.124A5.1 5.1 0 0040.293 4a4.693 4.693 0 00-4.691 4.691c0 5.267 5.314 6.649 8.935 11.856 3.423-5.175 8.934-6.757 8.934-11.856A4.693 4.693 0 0048.78 4z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}

function WhatsappEnquiry(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Component 42 \u2013 1">
        <g data-name="Component 41 \u2013 1">
          <g filter="url(#prefix__a)" data-name="Component 156 \u2013 4">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
          <g data-name="Group 8034">
            <g data-name="Group 8007">
              <path
                data-name="Path 6943"
                d="M34.5 17.446a11.954 11.954 0 00-18.81 14.42L14 38.06l6.335-1.662a11.92 11.92 0 005.71 1.455 11.958 11.958 0 008.456-20.407zm-8.452 18.388a9.9 9.9 0 01-5.055-1.386l-.364-.215-3.761.986 1-3.666-.236-.375a9.933 9.933 0 118.416 4.655zm5.448-7.441c-.3-.149-1.768-.873-2.04-.971s-.473-.149-.673.149-.771.971-.946 1.171-.349.225-.647.076a8.123 8.123 0 01-2.4-1.484 9.07 9.07 0 01-1.662-2.069c-.175-.3-.018-.462.131-.611s.3-.349.447-.524a1.992 1.992 0 00.3-.5.55.55 0 00-.025-.524c-.076-.149-.673-1.618-.92-2.219-.244-.582-.487-.5-.673-.513s-.375-.011-.571-.011a1.1 1.1 0 00-.8.375 3.353 3.353 0 00-1.044 2.491 5.8 5.8 0 001.218 3.088 13.311 13.311 0 005.1 4.51 17.054 17.054 0 001.7.629 4.077 4.077 0 001.88.12 3.081 3.081 0 002.029-1.415 2.527 2.527 0 00.175-1.418c-.075-.124-.275-.197-.575-.35z"
                fill="#707070"
              />
            </g>
          </g>
        </g>
        <g data-name="Group 8003">
          <path
            data-name="Path 6927"
            d="M45 3a9 9 0 11-9 9 9 9 0 019-9z"
            fill="#f07663"
          />
          <path
            data-name="Icon feather-phone-call"
            d="M45.04 10.076a2.077 2.077 0 011.64 1.64m-1.64-3.301a3.738 3.738 0 013.3 3.3m-.415 3.314v1.244a.831.831 0 01-.905.831 8.219 8.219 0 01-3.583-1.276 8.1 8.1 0 01-2.492-2.492 8.219 8.219 0 01-1.275-3.6.831.831 0 01.829-.906h1.244a.831.831 0 01.831.714 5.333 5.333 0 00.29 1.171.831.831 0 01-.187.876l-.527.524a6.645 6.645 0 002.491 2.492l.527-.527a.831.831 0 01.876-.187 5.333 5.333 0 001.167.291.831.831 0 01.716.843z"
            fill={props.selected ? '#fff' : '#f07663'}
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}

function OneTimeToRepeat(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 7998">
        <g data-name="Group 7971">
          <g filter="url(#prefix__a)" data-name="Component 242">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
        </g>
        <g data-name="Group 8018">
          <g data-name="Group 8013">
            <path
              data-name="Icon awesome-walking"
              d="M19.786 25.239a1.393 1.393 0 001.336-1.444 1.393 1.393 0 00-1.336-1.443 1.393 1.393 0 00-1.335 1.443 1.393 1.393 0 001.335 1.444zm2.63 4.483l-.648-.355-.27-.884a3.072 3.072 0 00-2.844-2.282 5.766 5.766 0 00-2.6.758 2.748 2.748 0 00-1.379 1.393l-.186.4a1 1 0 00.4 1.29.849.849 0 001.182-.43l.186-.409a.916.916 0 01.459-.463l.746-.325-.427 1.83a2.044 2.044 0 00.415 1.768l1.667 1.967a1.994 1.994 0 01.415.833l.509 2.2a.89.89 0 001.08.7.972.972 0 00.646-1.161l-.618-2.676a1.976 1.976 0 00-.415-.833l-1.265-1.491.479-2.07.153.5a1.884 1.884 0 00.882 1.113l.648.355a.849.849 0 001.182-.43 1.012 1.012 0 00-.4-1.293zm-6.369 4.23a1.884 1.884 0 01-.4.647l-1.386 1.507a1.02 1.02 0 000 1.362.842.842 0 001.258 0l1.652-1.786a1.974 1.974 0 00.4-.647l.376-1.016c-1.549-1.813-1.082-1.257-1.324-1.615l-.576 1.548z"
              fill={props.selected ? '#fff' : '#f07663'}
            />
          </g>
          <g data-name="Group 8016">
            <path
              data-name="Path 6927"
              d="M30.687 16a7.313 7.313 0 11-7.313 7.313A7.313 7.313 0 0130.687 16z"
              fill="#f07663"
            />
            <g
              data-name="Icon feather-repeat"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path data-name="Path 6944" d="M32.353 19.25l1.4 1.4-1.4 1.4" />
              <path
                data-name="Path 6945"
                d="M27.437 22.762v-.707a1.4 1.4 0 011.4-1.4h4.916"
              />
              <path
                data-name="Path 6946"
                d="M28.837 26.975l-1.4-1.409 1.4-1.4"
              />
              <path
                data-name="Path 6947"
                d="M33.758 23.464v.7a1.4 1.4 0 01-1.4 1.4h-4.921"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

function ProductLatencyBased(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 7971">
        <g filter="url(#prefix__a)" data-name="Component 242">
          <circle
            data-name="Ellipse 264"
            cx={21}
            cy={21}
            r={21}
            transform="translate(5 5)"
            fill={props.selected ? '#f07663' : '#fff'}
            stroke={props.isBorder ? '#F07967' : '#fff'}
          />
        </g>
        <g data-name="Group 7980" fill="#f07663">
          <path
            data-name="Icon awesome-cube"
            d="M19.4 26.25l-4.7 1.758a1.085 1.085 0 00-.7 1.015v5.082a1.083 1.083 0 00.6.968l4.7 2.348a1.076 1.076 0 00.968 0l4.7-2.348a1.081 1.081 0 00.6-.968v-5.082a1.082 1.082 0 00-.7-1.014l-4.71-1.759a1.065 1.065 0 00-.758 0zm.382 1.4l4.334 1.625v.025l-4.337 1.76-4.334-1.761v-.025zm.718 8.035v-3.361l3.612-1.467v3.022z"
            fill={props.selected ? '#fff' : '#f07663'}
          />
          <path
            data-name="Icon material-slow-motion-video"
            d="M31.581 20.551l-2.187-1.642v6.455l2.187-1.639 2.116-1.585zm0 0l-2.187-1.642v6.455l2.187-1.639 2.116-1.585zm0 0l-2.187-1.642v6.455l2.187-1.639 2.116-1.585zm-1.47-4.1V15a7.135 7.135 0 00-3.816 1.585l1.022 1.026a5.7 5.7 0 012.794-1.162zm-3.808 2.174l-1.026-1.022a7.135 7.135 0 00-1.585 3.816h1.449a5.7 5.7 0 011.162-2.794zm-1.162 4.228h-1.449a7.135 7.135 0 001.585 3.816l1.026-1.026a5.643 5.643 0 01-1.162-2.79zm1.155 4.834a7.159 7.159 0 003.816 1.585v-1.447a5.7 5.7 0 01-2.8-1.162l-1.017 1.025zm11.7-5.551a7.183 7.183 0 01-6.419 7.136v-1.447a5.737 5.737 0 000-11.375V15A7.183 7.183 0 0138 22.136z"
            fill={props.selected ? '#fff' : '#f07663'}
          />
        </g>
      </g>
    </svg>
  );
}

function CustomerLatencyBased(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 7998">
        <g data-name="Group 7971">
          <g filter="url(#prefix__a)" data-name="Component 242">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
        </g>
        <path
          data-name="Icon material-slow-motion-video"
          d="M31.823 21.917l-2.383-1.792v7.043l2.387-1.792 2.308-1.729zm0 0l-2.383-1.792v7.043l2.387-1.792 2.308-1.729zm0 0l-2.383-1.792v7.043l2.387-1.792 2.308-1.729zm-1.6-4.476V15.86a7.785 7.785 0 00-4.167 1.725l1.111 1.123a6.214 6.214 0 013.052-1.267zm-4.16 2.371l-1.123-1.111a7.785 7.785 0 00-1.729 4.163h1.585a6.214 6.214 0 011.267-3.052zm-1.267 4.617h-1.581a7.785 7.785 0 001.725 4.163l1.119-1.119a6.157 6.157 0 01-1.263-3.044zm1.26 5.274a7.811 7.811 0 004.163 1.729v-1.58a6.214 6.214 0 01-3.052-1.267l-1.111 1.118zm12.771-6.057a7.837 7.837 0 01-7 7.786v-1.58a6.259 6.259 0 000-12.411V15.86a7.837 7.837 0 016.999 7.786z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
        <path
          data-name="Icon awesome-user"
          d="M18.194 30.402a2.869 2.869 0 10-2.868-2.869 2.869 2.869 0 002.868 2.869zm2.008.717h-.374a3.9 3.9 0 01-3.268 0h-.374a3.013 3.013 0 00-3.012 3.012v.933a1.076 1.076 0 001.076 1.076h7.889a1.076 1.076 0 001.076-1.076v-.933a3.013 3.013 0 00-3.012-3.012z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}

function StoreBased(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 7998">
        <g data-name="Group 7971">
          <g filter="url(#prefix__a)" data-name="Component 242">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
        </g>
        <path
          data-name="Icon awesome-store"
          d="M37.455 20.621l-2.529-4.037A1.247 1.247 0 0033.87 16H18.128a1.247 1.247 0 00-1.056.584l-2.529 4.037a3.476 3.476 0 002.291 5.315 4.05 4.05 0 00.534.035 3.848 3.848 0 002.876-1.29 3.851 3.851 0 005.751 0 3.851 3.851 0 005.751 0 3.86 3.86 0 002.876 1.29 4.006 4.006 0 00.534-.035 3.473 3.473 0 002.299-5.315zm-2.825 6.6a4.944 4.944 0 01-1.149-.148v3.889H18.518v-3.888a5.162 5.162 0 01-1.149.148 5.258 5.258 0 01-.7-.047 4.9 4.9 0 01-.639-.14V34.7a1.246 1.246 0 001.245 1.25h17.456a1.246 1.246 0 001.247-1.25v-7.665a3.978 3.978 0 01-.639.14 5.419 5.419 0 01-.709.047z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}

function Fashionista(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 7998">
        <g data-name="Group 7971">
          <g filter="url(#prefix__a)" data-name="Component 242">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
        </g>
        <path
          data-name="Path 6948"
          d="M36.133 18.285c-1.729-2.87-3.6-3.251-6.329-3.285-.45.968-1.625 1.9-3.8 1.9s-3.389-.934-3.8-1.9c-2.767.035-4.6.415-6.329 3.285A26.228 26.228 0 0014 22.124l4.219 3.354.865-.726v11.654s1.729 1.072 6.916 1.072 6.916-1.072 6.916-1.072V24.718l.865.726L38 22.089a27.658 27.658 0 00-1.867-3.804zM25.965 29.939c-9.268-5.049-2.559-11.308 0-7.089 2.559-4.219 9.235 2.04 0 7.089z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
    </svg>
  );
}

function ValueBuyers(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 7998">
        <g data-name="Group 7971">
          <g filter="url(#prefix__a)" data-name="Component 242">
            <circle
              data-name="Ellipse 264"
              cx={21}
              cy={21}
              r={21}
              transform="translate(5 5)"
              fill={props.selected ? '#f07663' : '#fff'}
              stroke={props.isBorder ? '#F07967' : '#fff'}
            />
          </g>
        </g>
        <g data-name="Group 8025">
          <g data-name="Group 8013" fill="#f07663">
            <path
              data-name="Icon awesome-hand-holding-heart"
              d="M36.247 29.21a1.111 1.111 0 00-1.43 0l-3.1 2.48a2.137 2.137 0 01-1.343.47h-3.971a.537.537 0 110-1.074h2.628a1.117 1.117 0 001.117-.888 1.075 1.075 0 00-1.061-1.255h-5.37a3.95 3.95 0 00-2.487.883l-1.557 1.26H17.81a.539.539 0 00-.537.537v3.222a.539.539 0 00.537.537h11.976a2.151 2.151 0 001.343-.47l5.075-4.061a1.074 1.074 0 00.043-1.641z"
              fill={props.selected ? '#fff' : '#f07663'}
            />
            <path
              data-name="Icon awesome-user"
              d="M26.94 21.052a2.869 2.869 0 10-2.868-2.869 2.869 2.869 0 002.868 2.869zm2.008.717h-.374a3.9 3.9 0 01-3.268 0h-.374a3.013 3.013 0 00-3.012 3.012v.933a1.076 1.076 0 001.076 1.076h7.889a1.076 1.076 0 001.076-1.076v-.933a3.013 3.013 0 00-3.012-3.012z"
              fill={props.selected ? '#fff' : '#f07663'}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function Form(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d_300_4555)">
        <path
          d="M26 47c11.598 0 21-9.402 21-21S37.598 5 26 5 5 14.402 5 26s9.402 21 21 21z"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
      </g>
      <path
        d="M31.625 17h-3.75a1.875 1.875 0 10-3.75 0h-3.75a2.25 2.25 0 00-2.25 2.25v15.375a2.25 2.25 0 002.25 2.25h11.25a2.25 2.25 0 002.25-2.25V19.25a2.25 2.25 0 00-2.25-2.25zm-9.161 2.183A1.043 1.043 0 0023.48 20h5.04a1.043 1.043 0 001.016-.817h1.65a.442.442 0 01.439.442V34.25a.443.443 0 01-.439.443H20.814a.442.442 0 01-.439-.443V19.625a.443.443 0 01.439-.442h1.65zm2.085-1.433h.124a.377.377 0 00.067-.034.254.254 0 00.101-.094.375.375 0 00.034-.082.38.38 0 00.023-.064.377.377 0 000-.075v-.022a.361.361 0 000-.049.354.354 0 000-.052 1 1 0 01-.023-.278 1.125 1.125 0 112.216.274.354.354 0 000 .052.361.361 0 000 .049v.023a.376.376 0 000 .075.324.324 0 00.165.217.384.384 0 00.068.034h.022a.381.381 0 00.102 0h1.364v1.207a.293.293 0 01-.292.293h-5.04a.293.293 0 01-.293-.293V17.75h1.362zm8.576 16.875a1.5 1.5 0 01-1.5 1.5h-11.25a1.5 1.5 0 01-1.5-1.5V19.25a1.5 1.5 0 011.5-1.5h2.063v.683h-1.624a1.193 1.193 0 00-1.189 1.192V34.25a1.193 1.193 0 001.189 1.193h10.372a1.193 1.193 0 001.189-1.193V19.625a1.193 1.193 0 00-1.189-1.192h-1.623v-.683h2.062a1.5 1.5 0 011.5 1.5v15.375z"
        fill={props.selected ? '#fff' : '#f07663'}
      />
      <path
        d="M22.438 28.063a1.313 1.313 0 100-2.626 1.313 1.313 0 000 2.625zm0-1.875a.562.562 0 110 1.124.562.562 0 010-1.125zM24.875 27.125H30.5a.375.375 0 000-.75h-5.625a.375.375 0 000 .75zM22.438 23.563a1.313 1.313 0 100-2.626 1.313 1.313 0 000 2.625zm0-1.875a.562.562 0 110 1.124.562.562 0 010-1.125zM24.875 22.625H30.5a.375.375 0 000-.75h-5.625a.375.375 0 000 .75zM30.5 23.375h-2.625a.375.375 0 000 .75H30.5a.375.375 0 000-.75zM30.5 27.875h-2.625a.375.375 0 000 .75H30.5a.375.375 0 000-.75zM30.5 32.375h-2.625a.375.375 0 000 .75H30.5a.375.375 0 000-.75zM22.438 32.563a1.313 1.313 0 100-2.626 1.313 1.313 0 000 2.625zm0-1.876a.562.562 0 110 1.125.562.562 0 010-1.125zM24.875 31.625H30.5a.375.375 0 000-.75h-5.625a.375.375 0 000 .75z"
        fill={props.selected ? '#fff' : '#f07663'}
      />
      <defs>
        <filter
          id="prefix__filter0_d_300_4555"
          x={2}
          y={2}
          width={50}
          height={50}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_300_4555"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_300_4555"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

function BuildYourOwn(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d_301_4581)">
        <path
          d="M26 47c11.598 0 21-9.402 21-21S37.598 5 26 5 5 14.402 5 26s9.402 21 21 21z"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
      </g>
      <g
        clipPath="url(#prefix__clip0_301_4581)"
        stroke="#F07663"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M27.5 35.75h-9c-1.275 0-2.25-.975-2.25-2.25s.975-2.25 2.25-2.25h9c1.275 0 2.25.975 2.25 2.25s-.975 2.25-2.25 2.25zM23 22.25h-6V29h6v-6.75zM26 29h-3M26 26l9.75-8.25-1.5-1.5-9 6h5.25l.75-3.75M33.5 28.25h-.75V29c0 .825.675 1.5 1.5 1.5s1.5-.675 1.5-1.5V17.75"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_301_4581">
          <path fill="#fff" transform="translate(14 14)" d="M0 0h24v24H0z" />
        </clipPath>
        <filter
          id="prefix__filter0_d_301_4581"
          x={2}
          y={2}
          width={50}
          height={50}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_301_4581"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_301_4581"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

function NPS(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 54 54" {...props}>
      <defs>
        <filter
          id="prefix__a"
          x={0}
          y={0}
          width={54}
          height={54}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} result="b" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
        <style>
          {
            '.prefix__c,.prefix__d{fill:none;stroke:#f07663}.prefix__c{stroke-linecap:round;stroke-linejoin:round}'
          }
        </style>
      </defs>
      <g filter="url(#prefix__a)">
        <circle
          cx={21}
          cy={21}
          r={21}
          transform="translate(5 5)"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
      </g>
      <path
        d="M33.049 33.777h-6.648V22.643a3.02 3.02 0 001.638-1.789l4.986-1.676a.6.6 0 00.381-.765l-.381-1.147a.6.6 0 00-.765-.381l-4.458 1.494a3.013 3.013 0 00-5.633 1.5 2.986 2.986 0 00.038.379l-4.85 1.626a.6.6 0 00-.381.765l.384 1.146a.6.6 0 00.765.381l5.366-1.8a3.04 3.04 0 00.491.269V35.59a.6.6 0 00.6.6h8.461a.6.6 0 00.6-.6v-1.209a.6.6 0 00-.594-.604z"
        stroke={props.selected ? '#fff' : '#f07663'}
        fill="none"
      />
      <path
        d="M22.614 30.831a4.307 4.307 0 11-4.307-4.307 4.307 4.307 0 014.307 4.307z"
        stroke={props.selected ? '#fff' : '#f07663'}
        fill="none"
      />
      <path
        d="M16.584 31.692a2.325 2.325 0 001.723.861 2.325 2.325 0 001.723-.861M19.599 29.539"
        stroke={props.selected ? '#fff' : '#f07663'}
        fill="none"
      />
      <g>
        <path
          d="M36.614 26.524a4.307 4.307 0 11-4.307-4.307 4.307 4.307 0 014.307 4.307z"
          stroke={props.selected ? '#fff' : '#f07663'}
          fill="none"
        />
        <path
          d="M34.03 28.246s-.646.017-1.723.017-1.723-.017-1.723-.017M33.599 25.232"
          stroke={props.selected ? '#fff' : '#f07663'}
          fill="none"
        />
      </g>
      <path
        d="M18.5 22.805v4.021M32.5 18.476v4.021"
        stroke={props.selected ? '#fff' : '#f07663'}
        fill="none"
      />
    </svg>
  );
}

function ProductLaunch(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 40 40" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d_108_122)">
        <path
          d="M19 35c8.837 0 16-7.163 16-16S27.837 3 19 3 3 10.163 3 19s7.163 16 16 16z"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
        <path
          d="M24.314 26.839v3.069l-5.415 2.045-5.415-2.045v-3.07M13.484 23.771l5.415-2.045 5.415 2.045-5.415 2.046-5.415-2.046z"
          stroke="#F2755F"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.9 21.725l-1.625-1.535-5.415 2.046 1.625 1.535M18.9 21.725l1.624-1.535 5.414 2.046-1.624 1.535"
          stroke="#F2755F"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.485 23.77l-1.625 2.046 5.415 2.046 1.624-2.046M24.314 23.77l1.624 2.046-5.414 2.046-1.625-2.046"
          stroke="#F2755F"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.613 11.387a1.3 1.3 0 01.425-.94 1.458 1.458 0 011.004-.38c.374.003.732.148.994.4.262.254.407.595.403.949-.002.175-.04.348-.113.51a1.336 1.336 0 01-.311.43 1.458 1.458 0 01-1.004.38 1.454 1.454 0 01-.994-.401 1.297 1.297 0 01-.404-.948zm1.421-.653a.728.728 0 00-.501.19.65.65 0 00-.213.47.648.648 0 00.202.473c.13.127.31.2.497.201a.728.728 0 00.5-.19.65.65 0 00.213-.469.647.647 0 00-.2-.474.726.726 0 00-.497-.2z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
        <path
          d="M22.112 14.779a1.012 1.012 0 01-.393.478c-.18.118-.395.18-.614.177l-.609-.006.234.924a.317.317 0 01-.067.286.35.35 0 01-.125.093.372.372 0 01-.155.033l-2.83-.027a.37.37 0 01-.279-.132.325.325 0 01-.06-.287l.254-.92-.61-.006a1.102 1.102 0 01-.609-.189 1.01 1.01 0 01-.383-.486l-1.12-.011a.364.364 0 01-.248-.1.325.325 0 01-.101-.237l.01-1.002c.005-.414.146-.817.402-1.152a2.118 2.118 0 011.032-.723l.01-.886c.008-.767.239-1.518.667-2.17a4.366 4.366 0 011.76-1.53 1.81 1.81 0 011.595.014c1.46.74 2.364 2.185 2.346 3.748l-.01.887c.412.142.766.402 1.016.743.249.34.38.746.376 1.16l-.011 1.001a.325.325 0 01-.107.235.365.365 0 01-.25.096l-1.12-.011zM18.6 7.5a3.673 3.673 0 00-1.481 1.287 3.395 3.395 0 00-.562 1.826l-.008.77h.004l-.008.668h-.004l-.022 2.004h.004l-.005.38c.012.08.053.153.117.206a.366.366 0 00.23.083l4.247.042a.366.366 0 00.233-.08.33.33 0 00.12-.203l.005-.38.003.001.022-2.004h-.003l.008-.668h.003l.009-.77a3.388 3.388 0 00-.521-1.837 3.66 3.66 0 00-1.453-1.317A1.059 1.059 0 0018.6 7.5l.001.001zm3.58 6.611l.706.007.008-.667a1.278 1.278 0 00-.181-.67 1.376 1.376 0 00-.512-.494l-.02 1.824zm-6.347-1.886a1.38 1.38 0 00-.522.484 1.281 1.281 0 00-.196.666l-.007.667.705.007.02-1.824zm3.934 3.196l-1.57-.015-.185.667 1.925.019-.17-.67zM19.31 17.752a.325.325 0 00-.103-.234.364.364 0 00-.247-.098.365.365 0 00-.249.093.326.326 0 00-.108.232l-.019 1.67a.32.32 0 00.101.237.356.356 0 00.25.1.373.373 0 00.25-.095.335.335 0 00.107-.235l.018-1.67zM17.545 17.4c.093.002.183.038.249.101a.324.324 0 01.1.237l-.006.67c-.001.088-.04.173-.106.235a.365.365 0 01-.5-.005.325.325 0 01-.102-.237l.008-.67a.325.325 0 01.106-.235.364.364 0 01.25-.096zM20.726 17.766a.316.316 0 00-.099-.24.354.354 0 00-.251-.103.371.371 0 00-.253.097.332.332 0 00-.104.24l-.008.668a.318.318 0 00.1.238.356.356 0 00.25.1.37.37 0 00.25-.095.335.335 0 00.107-.235l.008-.67z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d_108_122"
          x={0}
          y={0}
          width={40}
          height={40}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_108_122"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_108_122"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

function NewCustomer(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 40 40" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d_108_128)">
        <path
          d="M19 35c8.837 0 16-7.163 16-16S27.837 3 19 3 3 10.163 3 19s7.163 16 16 16z"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
        <path
          d="M17.75 11.5a4.385 4.385 0 00-4.375 4.375c0 1.506.769 2.845 1.934 3.633-2.23.956-3.809 3.167-3.809 5.742h1.25c0-2.769 2.231-5 5-5 .86 0 1.659.224 2.363.606-.72.89-1.113 2-1.113 3.144 0 2.754 2.246 5 5 5s5-2.246 5-5-2.246-5-5-5a4.987 4.987 0 00-2.93.956 6.375 6.375 0 00-.879-.448 4.387 4.387 0 001.934-3.633A4.385 4.385 0 0017.75 11.5zm0 1.25a3.116 3.116 0 013.125 3.125A3.116 3.116 0 0117.75 19a3.116 3.116 0 01-3.125-3.125 3.116 3.116 0 013.125-3.125zm6.25 7.5A3.74 3.74 0 0127.75 24 3.74 3.74 0 0124 27.75 3.74 3.74 0 0120.25 24 3.74 3.74 0 0124 20.25zm-.625 1.25v1.875H21.5v1.25h1.875V26.5h1.25v-1.875H26.5v-1.25h-1.875V21.5h-1.25z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d_108_128"
          x={0}
          y={0}
          width={40}
          height={40}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_108_128"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_108_128"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

function Appointments(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 40 40" fill="none" {...props}>
      <g filter="url(#a)">
        <path
          d="M19 35c8.837 0 16-7.163 16-16S27.837 3 19 3 3 10.163 3 19s7.163 16 16 16Z"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
        <mask
          id="b"
          style={{
            maskType: 'alpha'
          }}
          maskUnits="userSpaceOnUse"
          x={10}
          y={10}
          width={18}
          height={18}
        >
          <path
            d="M26.5 11.688h-2.438v-1.125a.562.562 0 1 0-1.125 0v1.125h-3.375v-1.125a.562.562 0 1 0-1.125 0v1.125h-3.375v-1.125a.562.562 0 1 0-1.124 0v1.125H11.5a1.5 1.5 0 0 0-1.5 1.5V26.5a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V13.187a1.5 1.5 0 0 0-1.5-1.5Zm.375 14.812a.375.375 0 0 1-.374.375H11.5a.375.375 0 0 1-.375-.375V13.188a.375.375 0 0 1 .375-.374h2.438v1.125a.562.562 0 1 0 1.124 0v-1.125h3.376v1.125a.562.562 0 1 0 1.125 0v-1.125h3.375v1.125a.562.562 0 1 0 1.125 0v-1.125H26.5a.375.375 0 0 1 .374.374l.001 13.312Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill={props.selected ? '#fff' : '#f07663'}>
          <path d="M26.5 11.688h-2.438v-1.125a.562.562 0 1 0-1.125 0v1.125h-3.375v-1.125a.562.562 0 1 0-1.125 0v1.125h-3.375v-1.125a.562.562 0 1 0-1.124 0v1.125H11.5a1.5 1.5 0 0 0-1.5 1.5V26.5a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V13.187a1.5 1.5 0 0 0-1.5-1.5Zm.375 14.812a.375.375 0 0 1-.374.375H11.5a.375.375 0 0 1-.375-.375V13.188a.375.375 0 0 1 .375-.374h2.438v1.125a.562.562 0 1 0 1.124 0v-1.125h3.376v1.125a.562.562 0 1 0 1.125 0v-1.125h3.375v1.125a.562.562 0 1 0 1.125 0v-1.125H26.5a.375.375 0 0 1 .374.374l.001 13.312Z" />
          <path d="M24.063 11.688h-4.5v4.5h4.5v-4.5Zm0-1.125-4.5-.003v.003h4.5Zm-1.125 0-4.5-.004v.003h4.5Zm0 1.125v4.5h4.5v-4.5h-4.5Zm-3.375 0h-4.5v4.5h4.5v-4.5Zm0-1.125-4.5-.003v.003h4.5ZM19 10l.003-4.5L19 10Zm-.563.562-4.5-.003v.003h4.5Zm0 1.126v4.5h4.5v-4.5h-4.5Zm-3.375 0h-4.5v4.5h4.5v-4.5Zm0-1.125-4.5-.003v.003h4.5ZM14.5 10l.003-4.5L14.5 10Zm-.563.562-4.5-.003v.003h4.5Zm0 1.126v4.5h4.5v-4.5h-4.5Zm-2.437 0v4.5-4.5Zm-1.5 1.5-4.5-.003v.002H10ZM10 26.5H5.5 10Zm18-13.313h4.5v-.002l-4.5.002ZM26.875 26.5h4.5-4.5Zm-.374.375v4.5h.009l-.01-4.5ZM11.125 26.5h-4.5 4.5Zm0-13.312-4.5-.01v.01h4.5Zm.375-.374v4.5-4.5Zm2.438 0h4.5v-4.5h-4.5v4.5Zm0 1.125 4.5.003v-.003h-4.5Zm1.124 0 4.5.003v-.003h-4.5Zm0-1.125v-4.5h-4.5v4.5h4.5Zm3.376 0h4.5v-4.5h-4.5v4.5Zm0 1.125 4.5.003v-.003h-4.5Zm1.125 0 4.5.003v-.003h-4.5Zm0-1.125v-4.5h-4.5v4.5h4.5Zm3.375 0h4.5v-4.5h-4.5v4.5Zm0 1.125 4.5.003v-.003h-4.5Zm1.125 0 4.5.003v-.003h-4.5Zm0-1.125v-4.5h-4.5v4.5h4.5Zm2.437 0 .009-4.5H26.5v4.5Zm.374.374h4.5v-.01l-4.5.01Zm-.374-6h-2.438v9H26.5v-9Zm2.063 4.5v-1.125h-9v1.125h9Zm0-1.122c0-1.343-.532-2.63-1.48-3.58l-6.37 6.359a3.938 3.938 0 0 1-1.15-2.785l9 .006Zm-1.48-3.58a5.063 5.063 0 0 0-3.58-1.486l-.006 9a3.938 3.938 0 0 1-2.783-1.155l6.368-6.36ZM23.502 5.5c-1.342 0-2.63.532-3.58 1.48l6.36 6.369a3.937 3.937 0 0 1-2.786 1.151l.006-9Zm-3.58 1.48a5.062 5.062 0 0 0-1.485 3.58l9 .005a3.938 3.938 0 0 1-1.156 2.784l-6.36-6.369Zm-1.485 3.582v1.126h9v-1.126h-9Zm4.5-3.374h-3.375v9h3.375v-9Zm1.125 4.5v-1.125h-9v1.125h9Zm0-1.122c0-.665-.13-1.323-.384-1.938l-8.318 3.439c-.197-.478-.299-.99-.299-1.507l9 .006Zm-.384-1.938a5.064 5.064 0 0 0-1.097-1.643l-6.368 6.36a3.94 3.94 0 0 1-.853-1.278l8.317-3.439Zm-1.097-1.643a5.063 5.063 0 0 0-1.642-1.098l-3.45 8.312a3.937 3.937 0 0 1-1.276-.854l6.368-6.36ZM20.94 5.887a5.063 5.063 0 0 0-1.937-.387l-.006 9c-.517 0-1.029-.102-1.506-.3l3.45-8.313ZM19.003 5.5c-1.342 0-2.63.532-3.58 1.48l6.36 6.369a3.937 3.937 0 0 1-2.786 1.151l.006-9Zm-3.58 1.48a5.062 5.062 0 0 0-1.486 3.58l9 .005a3.937 3.937 0 0 1-1.155 2.784l-6.36-6.369Zm-1.486 3.582v1.126h9v-1.126h-9Zm4.5-3.374h-3.375v9h3.376v-9Zm1.125 4.5v-1.125h-9v1.125h9Zm0-1.122c0-.665-.13-1.323-.384-1.938l-8.317 3.439a3.94 3.94 0 0 1-.299-1.507l9 .006Zm-.384-1.938a5.064 5.064 0 0 0-1.096-1.643l-6.368 6.36a3.939 3.939 0 0 1-.853-1.278l8.317-3.439Zm-1.096-1.643a5.063 5.063 0 0 0-1.642-1.098l-3.45 8.312a3.937 3.937 0 0 1-1.276-.854l6.368-6.36ZM16.44 5.887a5.063 5.063 0 0 0-1.937-.387l-.006 9c-.517 0-1.029-.102-1.506-.3l3.45-8.313ZM14.504 5.5c-1.342 0-2.63.532-3.58 1.48l6.36 6.369a3.937 3.937 0 0 1-2.786 1.151l.006-9Zm-3.58 1.48a5.062 5.062 0 0 0-1.486 3.58l9 .005a3.938 3.938 0 0 1-1.155 2.784l-6.36-6.369Zm-1.486 3.582v1.126h9v-1.126h-9Zm4.5-3.374H11.5v9h2.438v-9Zm-2.437 0a6 6 0 0 0-4.242 1.756l6.363 6.366a3 3 0 0 1-2.121.878v-9ZM7.258 8.944a6 6 0 0 0-1.758 4.24l9 .005a3 3 0 0 1-.88 2.12L7.259 8.945ZM5.5 13.187V26.5h9V13.187h-9Zm0 13.313a6 6 0 0 0 1.757 4.242l6.364-6.364A3 3 0 0 1 14.5 26.5h-9Zm1.757 4.242A6 6 0 0 0 11.5 32.5v-9a3 3 0 0 1 2.121.878l-6.364 6.364ZM11.5 32.5h15v-9h-15v9Zm15 0a6 6 0 0 0 4.243-1.758l-6.364-6.364A3 3 0 0 1 26.5 23.5v9Zm4.243-1.758A6 6 0 0 0 32.5 26.5h-9a3 3 0 0 1 .879-2.122l6.364 6.364ZM32.5 26.5V13.187h-9V26.5h9Zm0-13.315a6 6 0 0 0-1.758-4.24l-6.363 6.365a3 3 0 0 1-.879-2.12l9-.005Zm-1.758-4.24A6 6 0 0 0 26.5 7.187v9a3 3 0 0 1-2.12-.878l6.362-6.366ZM22.375 26.5c0-1.092.433-2.14 1.205-2.913l6.37 6.357a4.875 4.875 0 0 0 1.425-3.444h-9Zm1.205-2.913a4.125 4.125 0 0 1 2.912-1.212l.018 9a4.875 4.875 0 0 0 3.44-1.43l-6.37-6.358Zm2.92-1.212h-15v9h15v-9Zm-15 0c1.094 0 2.143.435 2.917 1.209l-6.364 6.364a4.875 4.875 0 0 0 3.447 1.427v-9Zm2.917 1.209a4.125 4.125 0 0 1 1.208 2.916h-9c0 1.293.514 2.533 1.428 3.448l6.364-6.364Zm1.208 2.916V13.188h-9V26.5h9Zm0-13.303a4.125 4.125 0 0 1-1.211 2.911l-6.358-6.37a4.875 4.875 0 0 0-1.431 3.44l9 .019Zm-1.211 2.911a4.125 4.125 0 0 1-2.914 1.206v-9c-1.291 0-2.53.512-3.444 1.424l6.358 6.37ZM11.5 17.314h2.438v-9H11.5v9Zm-2.063-4.5v1.125h9v-1.125h-9Zm0 1.122c0 1.342.532 2.63 1.48 3.58l6.37-6.36a3.938 3.938 0 0 1 1.15 2.786l-9-.006Zm1.48 3.58a5.062 5.062 0 0 0 3.58 1.486l.006-9c1.044 0 2.045.416 2.783 1.155l-6.368 6.36Zm3.58 1.486c1.342 0 2.63-.532 3.58-1.48l-6.36-6.37a3.938 3.938 0 0 1 2.786-1.15l-.006 9Zm3.58-1.48a5.062 5.062 0 0 0 1.485-3.58l-9-.006c.001-1.044.417-2.045 1.156-2.783l6.36 6.368Zm1.485-3.583v-1.125h-9v1.125h9Zm-4.5 3.375h3.376v-9h-3.375v9Zm-1.124-4.5v1.125h9v-1.125h-9Zm0 1.122c-.001 1.342.531 2.63 1.48 3.58l6.368-6.36a3.938 3.938 0 0 1 1.151 2.786l-9-.006Zm1.48 3.58a5.062 5.062 0 0 0 3.579 1.486l.006-9c1.044 0 2.045.416 2.783 1.155l-6.368 6.36Zm3.579 1.486c1.342 0 2.63-.532 3.58-1.48l-6.36-6.37a3.938 3.938 0 0 1 2.786-1.15l-.006 9Zm3.58-1.48a5.062 5.062 0 0 0 1.485-3.58l-9-.006c.001-1.044.417-2.045 1.156-2.783l6.36 6.368Zm1.485-3.583v-1.125h-9v1.125h9Zm-4.5 3.375h3.375v-9h-3.375v9Zm-1.125-4.5v1.125h9v-1.125h-9Zm0 1.122c0 1.342.532 2.63 1.48 3.58l6.37-6.36a3.938 3.938 0 0 1 1.15 2.786l-9-.006Zm1.48 3.58a5.062 5.062 0 0 0 3.58 1.486l.006-9c1.044 0 2.045.416 2.783 1.155l-6.368 6.36Zm3.58 1.486c1.342 0 2.63-.532 3.58-1.48l-6.36-6.37a3.937 3.937 0 0 1 2.786-1.15l-.006 9Zm3.58-1.48a5.062 5.062 0 0 0 1.485-3.58l-9-.006c.001-1.044.417-2.045 1.156-2.783l6.36 6.368Zm1.485-3.583v-1.125h-9v1.125h9Zm-4.5 3.375H26.5v-9h-2.438v9Zm2.429 0a4.125 4.125 0 0 1-2.909-1.209l6.364-6.364a4.875 4.875 0 0 0-3.437-1.427l-.018 9Zm-2.909-1.209a4.125 4.125 0 0 1-1.208-2.908l9-.018a4.875 4.875 0 0 0-1.428-3.438l-6.364 6.364Zm-1.208-2.917.001 13.313h9V13.187h-9Z" />
        </g>
        <path
          d="M22.375 17.82H21.25a.282.282 0 0 1-.281-.282v-1.125c0-.155.126-.281.281-.281h1.125c.155 0 .281.126.281.281v1.125a.282.282 0 0 1-.281.281Zm-.281-1.126h-.563v.563h.563v-.563ZM19.563 17.82h-1.125a.282.282 0 0 1-.282-.282v-1.125c0-.155.127-.281.282-.281h1.125c.154 0 .28.126.28.281v1.125a.282.282 0 0 1-.28.281Zm-.282-1.126h-.562v.563h.562v-.563ZM16.75 17.82h-1.125a.282.282 0 0 1-.281-.282v-1.125c0-.155.126-.281.281-.281h1.125c.155 0 .281.126.281.281v1.125a.282.282 0 0 1-.281.281Zm-.281-1.126h-.563v.563h.563v-.563ZM13.938 17.82h-1.126a.282.282 0 0 1-.28-.282v-1.125c0-.155.126-.281.28-.281h1.126c.154 0 .28.126.28.281v1.125a.282.282 0 0 1-.28.281Zm-.282-1.126h-.562v.563h.562v-.563ZM25.188 20.35h-1.125a.282.282 0 0 1-.282-.28v-1.126c0-.154.127-.28.282-.28h1.125c.154 0 .28.126.28.28v1.125a.282.282 0 0 1-.28.282Zm-.282-1.124h-.562v.562h.562v-.562ZM22.375 22.882H21.25a.282.282 0 0 1-.281-.281v-1.125c0-.155.126-.282.281-.282h1.125c.155 0 .281.127.281.282V22.6a.282.282 0 0 1-.281.28Zm-.281-1.125h-.563v.562h.563v-.562ZM19.844 22.882h-1.125a.282.282 0 0 1-.282-.281v-1.125c0-.155.127-.282.282-.282h1.125c.154 0 .281.127.281.282V22.6a.282.282 0 0 1-.281.28Zm-.282-1.125H19v.562h.563v-.562ZM13.938 20.35h-1.126a.282.282 0 0 1-.28-.28v-1.126c0-.154.126-.28.28-.28h1.126c.154 0 .28.126.28.28v1.125a.282.282 0 0 1-.28.282Zm-.282-1.124h-.562v.562h.562v-.562ZM21.813 20.35a.846.846 0 0 1-.844-.843c0-.464.38-.844.843-.844.464 0 .844.38.844.844 0 .464-.38.844-.843.844Zm0-1.124a.282.282 0 0 0-.282.28.282.282 0 0 0 .563 0 .282.282 0 0 0-.281-.28ZM24.513 23.05a.846.846 0 0 1-.844-.843c0-.464.38-.844.844-.844.464 0 .843.38.843.844 0 .464-.38.844-.843.844Zm0-1.124a.282.282 0 0 0-.282.281.282.282 0 0 0 .563 0 .282.282 0 0 0-.281-.281ZM19 20.35a.846.846 0 0 1-.844-.843c0-.464.38-.844.844-.844.464 0 .844.38.844.844 0 .464-.38.844-.844.844Zm0-1.124a.282.282 0 0 0-.281.28c0 .155.126.282.281.282a.282.282 0 0 0 .281-.281.282.282 0 0 0-.281-.281ZM16.188 20.35a.846.846 0 0 1-.844-.843c0-.464.38-.844.844-.844.463 0 .843.38.843.844 0 .464-.38.844-.843.844Zm0-1.124a.282.282 0 0 0-.282.28c0 .155.127.282.281.282a.282.282 0 0 0 .282-.281.282.282 0 0 0-.282-.281ZM16.95 22.798a.292.292 0 0 1-.4 0l-.363-.362-.362.362a.276.276 0 0 1-.2.08.292.292 0 0 1-.2-.08.282.282 0 0 1 0-.398l.365-.362-.362-.362a.282.282 0 0 1 0-.397.282.282 0 0 1 .397 0l.362.362.362-.362a.282.282 0 0 1 .398 0 .282.282 0 0 1 0 .397l-.362.362.362.362a.28.28 0 0 1 .003.398Z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
      <defs>
        <filter
          id="a"
          x={0}
          y={0}
          width={40}
          height={40}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_109_86"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_109_86"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

function CustomerTag(props) {
  return (
    <svg width="50px" height="50px" viewBox="0 0 40 40" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d_108_126)">
        <path
          d="M19 35c8.837 0 16-7.163 16-16S27.837 3 19 3 3 10.163 3 19s7.163 16 16 16z"
          fill={props.selected ? '#f07663' : '#fff'}
          stroke={props.isBorder ? '#F07967' : '#fff'}
        />
        <path
          d="M28.795 18.166a.647.647 0 00.205-.47v-5.338a1.356 1.356 0 00-.27-.89c-.23-.296-.578-.444-1.029-.468h-5.518c-.18 0-.353.07-.48.194l-9.015 8.798c-.186.22-.273.491-.24.774.027.234.124.45.322.673l5.443 5.236c.21.204.49.319.782.319.275 0 .532-.098.818-.318l8.982-8.51zm-1.15-.747l-8.628 8.18-5.122-4.925 8.57-8.36h5.18v5.105zm-8.621-5.099h2.99a.668.668 0 00.677-.657.669.669 0 00-.678-.658h-3.271c-.18 0-.353.07-.48.194l-9.015 8.798c-.187.22-.273.492-.24.775.027.234.124.449.322.673l5.442 5.236c.21.204.49.318.782.318.276 0 .532-.097.819-.318l1.341-1.271a.643.643 0 00.012-.93.692.692 0 00-.958-.01l-1.191 1.134-5.123-4.924 8.57-8.36h.001zm5.476 4.809c.864 0 1.731-1.341 2.036-1.934 0-1.09-1.327-1.984-2.032-1.972-.962 0-2.018 1.11-2.031 1.971-.016 1.072.906 1.935 2.027 1.935zm.26.02c-.087.002-1.52-.114-1.52-.412-.106-.088-.303-.305-.366-.366s-.203-.32-.238-.401a3.718 3.718 0 01-.163-.776 4.92 4.92 0 01.148-.694c.035-.08.816-.939.879-1 .063-.061.29-.277.418-.277 0 .043.498-.001.586 0 .088-.002.915.245.996.277.081.032.597.49.66.552.063.06.242.451.276.532.035.08.099.551.1.639 0 .363-1.402 1.926-1.776 1.926z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
        <path d="M24.5 18a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" fill="#fff" />
        <path
          d="M24.36 15.124a1.167 1.167 0 101.638-1.663 1.167 1.167 0 00-1.638 1.663zm1.403-1.425a.834.834 0 11-1.17 1.188.834.834 0 011.17-1.188zM24.978 17.458a2.86 2.86 0 00-2.96-2.916.333.333 0 00-.224.1l-.616.624a.333.333 0 00.004.471l2.612 2.574a.333.333 0 00.471-.004l.616-.624c.06-.06.094-.14.097-.225zm-.95.615L21.416 15.5l.616-.626a2.528 2.528 0 012.612 2.573l-.616.626z"
          fill={props.selected ? '#fff' : '#f07663'}
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d_108_126"
          x={0}
          y={0}
          width={40}
          height={40}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={1} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_108_126"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_108_126"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export {
  WaitNode,
  StopNode,
  Decision,
  DecisionNode,
  LeadToOrder,
  ExistingCustomer,
  Notify,
  Act,
  Reward,
  More,
  NewLead,
  SalesOrder,
  ProductView,
  AbandonedCart,
  GiveOffer,
  SendSms,
  SendEmail,
  SendWebPush,
  SendWhatsapp,
  FbMessenger,
  OrderPlaced,
  CaptureWishlist,
  FbInterest,
  DroppedOffActivation,
  CrossSell,
  AddToCart,
  InstaInterest,
  WhatsappEnquiry,
  OneTimeToRepeat,
  ProductLatencyBased,
  CustomerLatencyBased,
  StoreBased,
  Fashionista,
  ValueBuyers,
  Form,
  BuildYourOwn,
  NPS,
  ProductLaunch,
  NewCustomer,
  Appointments,
  CustomerTag
};
